import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "2d7cd05c-ff4d-438e-a5dc-e23719c8c9ec",
    content: "In diffuse sound reflection the sound is proportional with the sine of the incidence angle.",
    options: {},
  },
  {
    id: "0fa37325-0d2f-44ba-a7db-edacfd424cdb",
    content: "In diffuse sound reflection the sound is proportional with the cosine of the reflection angle",
    options: {},
  },
  {
    id: "de9c27d4-39cc-45e7-8e52-a5fa8d7b1dd6",
    content: "For all sound reflections the sound is proportional with the sine of the incidence angle.",
    options: {},
  },
  {
    id: "acd1c995-d4ed-40d9-b7e3-8e8308dea8ba",
    content: "For all sound reflections the sound is proportional with the cosine of the incidence angle.",
    options: {},
  },
];

export const task: Task = {
  id: "a81f5ab6-22f7-4c28-916d-e1c5559e02e7",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["0fa37325-0d2f-44ba-a7db-edacfd424cdb"],
};
